import { Alert, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useVersionCheck } from '@/hooks/useVersionCheck';

export function NewVersionBanner() {
  const { newVersionAvailable, refresh } = useVersionCheck();

  if (!newVersionAvailable) return null;

  return (
    <Alert
      type="info"
      showIcon
      message="A new version of Merchant Center is available."
      description="Refresh the page to load the latest version and avoid errors from outdated code."
      action={
        <Button type="primary" size="small" icon={<ReloadOutlined />} onClick={refresh}>
          Refresh
        </Button>
      }
      style={{
        borderRadius: 0,
        textAlign: 'center',
        zIndex: 9999,
      }}
    />
  );
}
